<section>
    <div>
        <h5 class="close-area">
            <i class="fas fa-times" (click)="dismiss()"></i>
        </h5>
        <h1 class="-blue">Recuperação de Senha</h1>
        <form [formGroup]="form" (ngSubmit)="sendEmail()">
            <div class="c-form-row">
                <div class="c-form-column">
                    <div class="input-container">
                        <input type="text" formControlName="email" name="email" class="o-input"
                            placeholder="Digite o email cadastrado para enviarmos o link de recuperação">
                    </div>
                </div>
            </div>
            <div class="c-form-row -flexCenter">
                <div class="c-form-column -flex -flexEnd">
                    <button type="submit" class="o-button -blue">Enviar</button>
                </div>
            </div>
        </form>
    </div>
</section>